<template>
  <div class="click-more">
    <div v-if="btnHide">没有更多资料</div>
    <el-button v-else round size="small" @click="showMore">显示更多</el-button>
  </div>
</template>

<script>
export default {
  name: 'ClickMoreButton',
  props: {
    btnHide: {
      type: Boolean,
      default: undefined
    }
  },
  methods: {
    showMore() {
      this.$emit('show-more')
    }
  }
}
</script>

<style lang="scss" scoped>
.click-more {
  text-align: center;
  width: 100%;
  padding-top: 12Px;
  padding-bottom: 8Px;
}
</style>
